/*\
 * 常量: API / Mutations / Actions 名称
\*/

/*\
 * 用户相关
\*/
const LOGIN_PASSWORD = 'member/login/password';
const LOGIN_PHONE = 'member/login/phone';
const GET_CAPTCHA = 'member/get/captcha';
const USER_LOGIN = "member/user/login";
const SEND_MSG = 'member/send/msg';
const CHECK_CAPTCHA = 'member/check/captcha';
const USER_EXIST = "member/user/exist";
const USER_REGISTER = "member/user/register";
const SOCIAL_LIST = "member/social/list";
const LOGIN_SOCIAL = "member/login/social";
const SET_PASSWORD = "member/set/password";
const LOGOUT = "member/user/logout";
const FOOTPRINT_ADD = "member/addFootprint";
const FOOTPRINT_LIST = "member/showFootprint";
const FAV_LIST = "member/showFav";
const FAV_ADD = "member/addFav";
const FAV_DEL = "member/delFav";
const FAV_PIDS_LIST = "member/getFavPids";
const ADDRESS_ADD = "member/addAddress";
const ADDRESS_DELETE = "member/delAddress";
const ADDRESS_UPDATE = "member/updateAddress";
const ADDRESS_SET_DEFAULT = "member/setDefaultAddress";
const ADDRESS_LIST = "member/showAddress";
const GET_ACCOUNT_INFO = "member/user/account";
const GET_PROFILE = "member/user/info";
const COUPON_ADD = "member/addCoupon";
const COUPON_LIST = "member/allCoupons";
const APPROACH_INFO = "member/approach/info";
const WX_WEB_AUTHORIZE = "order/api/pay/getAccess";
const POINTS_MALL_LIST = "member/pointmall/list";
const POINTS_MALL_EXCHANGE = "member/pointmall/convert";
const POINTS_MALL_HISTORY = "member/pointmall/my/convert"
const SOCIAL_LOGIN = "member/social/login";
const NOTICE = "member/bar_pop";
/*\
 * 类目 & 商品
\*/
const CATEGORY_INFO = "goods/outward/product/getCatInfo";
const GOODS_INFO = "goods/outward/product/getProduct";
const GET_STOCK = "goods/outward/get/stock";
const BATCH_GET_STOCK = "goods/outward/get/batchStock";
const UPDATE_STOCK = "goods/outward/update/stock";
const BATCH_UPDATE_STOCK = "goods/outward/update/batchStock";
const RECOMMEND_LIST = "goods/outward/product/recommend";
const STORE_LIST = "member/StoreList";
const QUERY_POST_TRIAL = 'order/api/new/trial/detail';
const PDP_COUPONS = 'member/coupon/getPdpCoupons';
const PDP_USER_COUPONS = 'member/coupon/getPdpDetailCoupons';
const GET_LIVE_INFO = 'member/wx/getLiveInfo';
const GET_REL_PRODUCTRULES = 'member/getRelProductRules';
const GET_ADDITIONAL_GIFT = 'member/coupon/getAdditionalGift';


/*\
 * 购物车 & 订单 & 支付
\*/
const CART_GET = "order/api/getCartInfo";
const CART_ADD = "order/api/addToCart";
const CART_UPDATE = "order/api/updateOption";
const CART_UPDATE_SELECTED = "order/api/updateSelect";
const CART_DELETE = "order/api/delCart";
const CART_STOCK_CHECK = "order/api/cartCheckStock";
const ORDER_CONFIRM = "order/api/confirm";
const VISITOR_CONFIRM = "order/api/visitor/confirm";
const ORDER_CREATE = "order/api/createOrder";
const VISITOR_CREATE = "order/api//visitor/add/order";
const ORDER_LIST = "oms/orders/list";
const ORDER_INFO = "orders/details";
const ORDER_CANCEL = "order/api/cancel";
const ORDER_PAY = "order/api/pay/index";
const VISITOR_ORDER_PAY = "order/api/visitor/orderPay";
const ORDER_REFUND = "order/api/pay/refund";
const ORDER_STAGES_INFO = "order/api/pay/getStagesInfo";
const ORDER_PAY_STATUS_QUERY = "";
const ORDER_GA_QUERY = "order/api/pay/GaQuery";
const TRIAL_LIST = "order/api/trial/list";
const TRAIAL_ORDER_CREATE = "order/api/trial/createOrder"
const TRAIAL_ORDER_CREATE_NEW = "order/api/new/trial/createOrder"
const TRIAL_ORDER_CONFIRM = "order/api/trial/confirm"
const TRIAL_ORDER_CONFIRM_NEW = "order/api/new/trial/confirm"
const ADD_INVOICE = "oms/add/invoice"
const SEND_INVOICE_EMAIL = "oms/sendInvoiceEmail"
const INVOICE_QUERY = "oms/invoiceQuery"
/*\
 * 搜索相关
\*/
const HOTKEYWORDS = "goods/search/getHotKeywords";
const KEYWORDLIST = "goods/keywordList";
const HOT_SALE = "goods/outward/product/hotSale ";

/*\
 * 组件相关常量: API 名称
\*/
const $CMP_MENU_PRIMARY = "navication";
const $CMP_MENU_SECONDARY = "navication1";
const $CMP_CATEGORY_LIST = "goods/outward/product/getProductList";
const $CMP_RECOMMEND_LIST = "goods/outward/product/recommend";

/*\
 * 页面相关常量: API 名称
\*/
const $PAGE_HOME_PRIMARY = "home";
const $PAGE_HOME_SECONDARY = "home_hair";
const $PAGE_SOIN = "soin";
const $PAGE_MAQUILLAGE = "maquillage";
const $PAGE_PARFUMS = "";
const $PAGE_CHEVEUX = "";
const $PAGE_OFFRES = "";
const $PAGE_EXCLUSIVITÉS = "";
const $PAGE_NOTRE_EXPERTISE = "";
const $PAGE_INSTITUTS_ET_SPAS = "";

/*\
 * DashBoard
\*/
const REPORT_BROWSER_PDP = "goods/pddReport";
const REPORT_BROWSER_PLP = "goods/report/catView";
const REPORT_ADD_TO_CART = "goods/report/addCart";
const REPORT_PAY_SUCESS = "oms/oms/paysuccessreport";
const SITE_CONFIG = "member/site/config";
//获取小程序跳转地址
const MIN_PROGRAMN = "oms/getUrlScheme"
// 会员领取优惠卷
const GET_COUPON = "member/coupon/grantCoupon"

/*\
 * 埋点数据
\*/

const REPORT_CHANNEL = "member/mark/activity";




export default {
  GET_COUPON,
  MIN_PROGRAMN,
  //埋点
  REPORT_CHANNEL,
  // 用户相关
  LOGIN_PASSWORD,
  LOGIN_PHONE,
  GET_CAPTCHA,
  USER_LOGIN,
  SEND_MSG,
  CHECK_CAPTCHA,
  USER_EXIST,
  USER_REGISTER,
  SOCIAL_LIST,
  LOGIN_SOCIAL,
  SET_PASSWORD,
  LOGOUT,
  FOOTPRINT_ADD,
  FOOTPRINT_LIST,
  FAV_LIST,
  FAV_ADD,
  FAV_DEL,
  FAV_PIDS_LIST,
  ADDRESS_ADD,
  ADDRESS_DELETE,
  ADDRESS_UPDATE,
  ADDRESS_SET_DEFAULT,
  ADDRESS_LIST,
  GET_ACCOUNT_INFO,
  GET_PROFILE,
  COUPON_ADD,
  COUPON_LIST,
  APPROACH_INFO,
  WX_WEB_AUTHORIZE,
  POINTS_MALL_LIST,
  POINTS_MALL_EXCHANGE,
  POINTS_MALL_HISTORY,
  SOCIAL_LOGIN,
  NOTICE,
  // 类目 & 商品
  CATEGORY_INFO, GOODS_INFO, GET_STOCK, BATCH_GET_STOCK, UPDATE_STOCK, BATCH_UPDATE_STOCK, RECOMMEND_LIST, STORE_LIST, QUERY_POST_TRIAL,PDP_COUPONS,PDP_USER_COUPONS,GET_LIVE_INFO,GET_REL_PRODUCTRULES,GET_ADDITIONAL_GIFT,
  // 购物车 & 订单 & 支付
  CART_GET, CART_ADD, CART_UPDATE, CART_UPDATE_SELECTED, CART_DELETE, CART_STOCK_CHECK,
  ORDER_CONFIRM, VISITOR_CONFIRM, ORDER_CREATE, ORDER_LIST, ORDER_INFO, ORDER_CANCEL, ORDER_PAY, ORDER_REFUND, ORDER_STAGES_INFO, ORDER_PAY_STATUS_QUERY, ORDER_GA_QUERY,
  TRIAL_LIST, TRAIAL_ORDER_CREATE, TRAIAL_ORDER_CREATE_NEW, TRIAL_ORDER_CONFIRM, TRIAL_ORDER_CONFIRM_NEW, ADD_INVOICE, SEND_INVOICE_EMAIL, INVOICE_QUERY,
  //搜索
  HOTKEYWORDS, KEYWORDLIST, HOT_SALE,
  // 组件相关常量: API 名称
  $CMP_MENU_PRIMARY, $CMP_MENU_SECONDARY, $CMP_CATEGORY_LIST, $CMP_RECOMMEND_LIST,
  // 页面相关常量: API 名称
  $PAGE_HOME_PRIMARY, $PAGE_HOME_SECONDARY, $PAGE_SOIN, $PAGE_MAQUILLAGE, $PAGE_PARFUMS, $PAGE_CHEVEUX, $PAGE_OFFRES, $PAGE_EXCLUSIVITÉS, $PAGE_NOTRE_EXPERTISE, $PAGE_INSTITUTS_ET_SPAS,
  // DashBoard
  REPORT_BROWSER_PDP, REPORT_BROWSER_PLP, REPORT_ADD_TO_CART, REPORT_PAY_SUCESS, SITE_CONFIG, VISITOR_CREATE, VISITOR_ORDER_PAY
}